var _this = this;
import * as tslib_1 from "tslib";
import { is3SFeatureEnabled, isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { lazyLogSearchResultInteraction } from 'owa-search-service';
import { orchestrator } from 'satcheljs';
import { userMailInteractionAction } from 'owa-mail-actions';
orchestrator(userMailInteractionAction, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        if (is3SFeatureEnabled('sea-qf') &&
            is3SFeatureEnabled('sea-resultInstrumentation') &&
            !isMailFeatureEnabled('sea-commonSearchBox') &&
            actionMessage.instrumentationContexts) {
            // Rank is an index + 1 denoting the position of current rows(s) being acted upon
            actionMessage.instrumentationContexts.forEach(function (instrumentationContext) {
                if (instrumentationContext) {
                    lazyLogSearchResultInteraction.importAndExecute(instrumentationContext.traceId, actionMessage.interactionType, instrumentationContext.referenceKey ||
                        (instrumentationContext.index + 1).toString(), new Date());
                }
            });
        }
        return [2 /*return*/];
    });
}); });
//# sourceMappingURL=onUserMailInteractionOrchestrator.js.map